import React, { useState, useEffect } from "react";

import "react-chat-widget/lib/styles.css";

import "/node_modules/flag-icons/css/flag-icons.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import AuthLayout from "./Layout/index";
import Signup from "./pages/common/auth/Signup";
import EmailVerification from "./pages/common/auth/EmailVerification";
import Login from "./pages/common/auth/Login";
import ForgotPassword from "./pages/common/auth/ForgotPassword";
import ChangePassword from "./pages/common/auth/ChangePassword";
import Logout from "./pages/common/auth/Logout";
import MeetingRoom from "./pages/common/chime/MeetingRoom";
import MeetingRoomTrsln from "./pages/common/chime/MeetingRoomTrsln";
import MeetingRoomTrspt from "./pages/common/chime/MeetingRoomTrspt.js";
import MeetingRoomV2 from "./pages/common/chime/MeetingRoomV2";
import MeetingRoomMini from "./pages/common/chime/MeetingRoomMini";
import MeetingRoomO3Mini from "./pages/common/chime/MeetingRoomO3Mini.js";
import ChatMoslem from "./pages/common/prayer-room/ChatMoslem";
import ChatChristian from "./pages/common/prayer-room/ChatChristian";

import CancerCommunity from "./pages/common/medical-support/CancerCommunity";
import CardiovascularCommunity from "./pages/common/medical-support/CardiovascularCommunity";
import DiabetesCommunity from "./pages/common/medical-support/DiabetesCommunity";
import GastroIntestinal from "./pages/common/medical-support/GastroIntestinal";
import GeriatricsCommunity from "./pages/common/medical-support/GeriatricsCommunity";
import HypertensionCommunity from "./pages/common/medical-support/HypertensionCommunity";
import InfeciousCommunity from "./pages/common/medical-support/InfeciousCommunity";
import MentalHealthCommunity from "./pages/common/medical-support/MentalHealthCommunity";
import ObGynCommunity from "./pages/common/medical-support/ObGynCommunity";
import PediatricsCommunity from "./pages/common/medical-support/PediatricsCommunity";
import WellnessNutrition from "./pages/common/medical-support/WellnessNutrition";
import QrCodePrescription from "./pages/common/chime/QrCodePrescription";

import Home from "./pages/patient/home/Home";
import Isabel from "./pages/patient/home/SitePalIntegration";
import EditProfile from "./pages/patient/profile/Profile";
import PointOfCare from "./pages/patient/profile/PointOfCare";
import SearchChatGpt from "./pages/patient/profile/SearchChatGpt";
import BotChatGpt from "./pages/patient/profile/BotChatGpt";
import AnalysisChatGpt from "./pages/patient/profile/AnalysisChatGpt";
import PatientStarpilot from "./pages/patient/profile/Starpilot.js";
import SingleMicStarpilot from "./pages/patient/profile/SingleMicStarpilot.js";
import AutoPrescriptionPatientStarpilot from "./pages/patient/prescription/AutoPrescriptionStarpilot.js";
import DoctorListInPatient from "./pages/patient/doctor/DoctorPriestList.js";
import DoctorAppointment from "./pages/patient/doctor/DoctorAppointment";
import DoctorMeetingStatus from "./pages/patient/meeting-status/MeetingStatus";

import MyAppointments from "./pages/patient/my-appointments/MyAppointments";

import AboutUs from "./pages/patient/static/StaticAboutUsPage";
import Policy from "./pages/patient/static/StaticPrivacyPolicyPage";
import Terms from "./pages/patient/static/StaticTerms&ConditionPage";
import SplashScreen from "./pages/patient/splash-screen/SplashScreen";
import SplashScreenPriest from "./pages/Priest/splash-screen/SplashScreen.js";
import Feedback from "./pages/patient/feedback/Feedback";
import Support from "./pages/patient/support/Support";
import PatientShareMedical from "./pages/patient/share-medical/ShareMedical";
import PermissionCode from "./pages/patient/permission-code/PermissionCode";
import ReportGenerate from "./pages/patient/report/ReportGenerate";
import ReportGeneration from "./pages/patient/report/ReportGeneration";
import BookAppointment from "./pages/patient/doctor/BookAppointment";
import AiDoctor2 from "./pages/patient/ai-doctor-2/AiDoctor2";
import AiDoctor3 from "./pages/patient/ai-doctor-3/AiDoctor3";
import DoctorOptions from "./pages/patient/doctor-options/DoctorOptions";
import PatientDocsumoResults from "./pages/patient/ocr/DocsumoResults";
import PatientChatgpt from "./pages/patient/ocr/Chatgpt";

import DoctorHome from "./pages/doctor/home/DoctorHome";
import DoctorPoc from "./pages/doctor/doctor-poc/DoctorPoc";
import DoctorFeedback from "./pages/doctor/feedback/Feedback";
import DoctorSupport from "./pages/doctor/support/Support";
import PatientList from "./pages/doctor/patient/PatientList";
import DoctorEditProfile from "./pages/doctor/profile/DoctorProfile";
import DocScanChatGpt from "./pages/doctor/profile/ScanChatGpt";
import ShareMedical from "./pages/doctor/share-medical/ShareMedical";
import DoctorSplashScreen from "./pages/doctor/splash-screen/SplashScreen";

import DoctorAboutUs from "./pages/doctor/static/StaticAboutUsPage";
import DoctorPolicy from "./pages/doctor/static/StaticPrivacyPolicyPage";
import DoctorTerms from "./pages/doctor/static/StaticTerms&ConditionPage";
import DoctorList from "./pages/doctor/doctor-list/DoctorList";
import DoctorIsabel from "./pages/doctor/home/SitePalIntegration";
import Prescription from "./pages/doctor/prescription/Prescription";
import DoctorBotChatGpt from "./pages/doctor/profile/BotChatGpt";
import DoctorSearchChatGpt from "./pages/doctor/profile/SearchChatGpt";
import Starpilot from "./pages/doctor/profile/Starpilot.js";
import SingleMicStarpilotDoctor from "./pages/doctor/profile/SingleMicStarpilot.js";
import DoctorAnalysisChatGpt from "./pages/doctor/profile/AnalysisChatGpt";
import Appointment from "./pages/doctor/doctor-appoinment/DoctorAppointment";
import DoctorBinah from "./pages/doctor/binah/Binah";

import DocAiDoctor2 from "./pages/doctor/ai-doctor-2/AiDoctor2";
import DocAiDoctor3 from "./pages/doctor/ai-doctor-3/AiDoctor3";

import DoctorReportGenerate from "./pages/doctor/report/ReportGenerate";
import DoctorReportGeneration from "./pages/doctor/report/ReportGeneration";
import NewDoctorList from "./pages/doctor/doctor-list/NewDoctorList";
import DoctorAvailability from "./pages/doctor/doctor-availability/DoctorAvailability";
import PatientAppointment from "./pages/doctor/patient/PatientAppoinment";
import MeetingStatus from "./pages/doctor/meeting-status/MeetingStatus";
import MeetingRecord from "./pages/doctor/meeting-record/MeetingRecord";
import PatientWaiting from "./pages/doctor/patient-waiting/PatientWaiting";
import PermissionCodeRequest from "./pages/doctor/permission-code-request/PermissionCodeRequest";
import SetTimeslot from "./pages/doctor/set-timeslot/SetTimeslot";
import ShareMedicalList from "./pages/doctor/share-medical/ShareMedicalList";
import AutoPrescriptionStarpilot from "./pages/doctor/prescription/AutoPrescriptionStarpilot.js";
import AutoPrescription from "./pages/doctor/prescription/AutoPrescription";
import AutoPrescriptionPoc from "./pages/doctor/prescription/AutoPrescriptionPoc";
import AutoPrescriptionPocPatient from "./pages/patient/prescription/AutoPrescriptionPoc";
import ChemistList from "./pages/doctor/chemist-list/ChemistList";
import DocsumoResults from "./pages/doctor/ocr/DocsumoResults";
import Chatgpt from "./pages/doctor/ocr/Chatgpt";
import DoctorOwnOptions from "./pages/doctor/doctor-options/DoctorOptions";
import Subscription from "./pages/patient/Subscription/index.js";
import PrescriptionMail from "./pages/common/prescription/Prescription.js";
import DoctorAppointments from "./pages/doctor/patient/MyAppointments.js";
import DoctorFeedbackList from "./pages/doctor/feedbackList/FeedbackList.js";
import PatientFeedbackList from "./pages/patient/feedbackList/FeedbackList.js";
import DoctorFeedbackDetail from "./pages/doctor/feedbackList/Feedback.js";
import PatientFeedbackDetail from "./pages/patient/feedbackList/Feedback.js";
import NewFeedbackDoctor from "./pages/doctor/new-feedback/NewFeedback.js";
import NewFeedbackPatient from "./pages/patient/new-feedback/NewFeedback.js";
import SocialService from "./pages/common/medical-support/SocialService.js";
import HomePage from "./pages/patient/static/HomePage.js";
import ContactPage from "./pages/patient/static/ContactPage.js";
import ServicePage from "./pages/patient/static/ServicePage.js";
import MedicalSupprotRoom from "./pages/common/medical-support-room/index.js";
import { initializeSocket } from "./helpers/socket.js";
import MeetingRoomSingleMic from "./pages/common/chime/MeetingRoomSingleMic.js";
import MeetingInitialize from "./pages/common/chime/MeetingInitialize.js";
import SinglemicHistory from "./pages/doctor/single-mic-history/SinglemicHistory.js";
import SinglemicMeetingDetail from "./pages/doctor/single-mic-history/SinglemicMeetingDetail.js";
import SingleUserHistory from "./pages/doctor/profile/SingleUserHistory.js";
import SingleuserMeetingDetail from "./pages/doctor/profile/SingleuserMeetingDetail.js";
import PriestSupportRoom from "./pages/Priest/PriestSupportRoom/index.js";
import PriestHome from "./pages/Priest/PriestHome.js";
import LiveStreaming from "./pages/Priest/VideoStreaming/LiveStreaming.js";
import PostralReport from "./pages/common/prescription/PostralReport.js";

function App() {
  const [chat, setChat] = useState();
  const userId = localStorage.getItem("user_id");

  const userRole = localStorage.getItem("user_login_type_role");

  useEffect(() => {
    if (userId) {
      initializeSocket(userId);
    }
  }, [userId]);
  console.log(userRole, "userRolessss");

  if (!localStorage.getItem("user_login_type_role", false)) {
    return (
      <div className="App h-100">
        <BrowserRouter basename={"/"}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/service-page" element={<ServicePage />} />
            <Route path="/log-in" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/home" element={<Home />} />
            <Route path="/patient/splash-screen" element={<SplashScreen />} />
            <Route path="/verify/:token" element={<EmailVerification />} />
            {/* <Route
              path="/meeting/:appointmentid/:meetingid"
              element={<MeetingRoom />}
            /> */}
            <Route
              path="/meeting-trsln/:appointmentid/:meetingid"
              element={<MeetingRoomTrsln />}
            />
            <Route
              path="/meeting-trspt/:appointmentid/:meetingid"
              element={<MeetingRoomTrspt />}
            />
            <Route
              path="/auto-prescription/:id"
              element={<PrescriptionMail />}
            />
            <Route path="/pastoral-summary/:id" element={<PostralReport />} />

            <Route
              path="/meeting-single-mic/:appointmentid/:meetingid"
              element={<MeetingRoomSingleMic />}
            />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  } else if (userRole === "1") {
    return (
      <div className="App h-100">
        <BrowserRouter basename={"/"}>
          <Routes>
            <Route element={<AuthLayout chat={chat} setChat={setChat} />}>
              <Route path="/" element={<Home />} />
              <Route
                path="/auto-prescription/:id"
                element={<PrescriptionMail />}
              />
              <Route path="/pastoral-summary/:id" element={<PostralReport />} />
              <Route path="/patient/home" element={<Home />} />
              <Route path="/patient/splash-screen" element={<SplashScreen />} />
              <Route path="/patient/isabel" element={<Isabel />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/patient/edit-profile" element={<EditProfile />} />
              <Route
                path="/change-password&security"
                element={<ChangePassword />}
              />
              <Route path="/patient/point-of-care" element={<PointOfCare />} />
              <Route
                path="/patient/bot-chat-gpt/:poc_type"
                element={<BotChatGpt />}
              />
              <Route
                path="/patient/carepoint/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route path="/patient/starpilot" element={<PatientStarpilot />} />
              <Route
                path="/patient-priest/starpilot"
                element={<PatientStarpilot />}
              />
              <Route
                path="/patient/single-mic-starpilot"
                element={<SingleMicStarpilot />}
              />
              <Route
                path="/patient/auto-prescription-starpilot"
                // element={<AutoPrescriptionPatientStarpilot />}
                element={<AutoPrescriptionStarpilot />}
              />
              <Route
                path="/meeting/:appointmentid/:meetingid"
                element={<MeetingRoom />}
              />
              <Route
                path="/patient/indication-checker/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/drug-interaction-revision/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/drug-allergy/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/dosing-medical-calculation/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route path="/patient/subscription" element={<Subscription />} />
              <Route
                path="/patient/pill-identification/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/medical-videos-articles/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/iv-compatibility-checker/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/laboratory-manual/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/icd-11-lookup-tool/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/notes-favorites/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/differential-diagnosis-generator/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/search-chat-gpt/:poc_type"
                element={<SearchChatGpt />}
              />
              <Route
                path="/patient/dr-aiva/:poc_type"
                element={<SearchChatGpt drAiva={true} />}
              />
              <Route
                path="/patient/share-analyse-record/:poc_type"
                element={<AnalysisChatGpt />}
              />
              <Route
                path="/patient/radiography&dermatology-illustration/:poc_type"
                // element={<ScanChatGpt />}
                element={<DocScanChatGpt />}
              />
              <Route
                path="/patient/doctor-list"
                element={<DoctorListInPatient />}
              />
              <Route
                path="/patient-priest/doctor-list"
                element={<DoctorListInPatient />}
              />
              <Route
                path="/patient/priest-list"
                element={<DoctorListInPatient />}
              />
              <Route
                path="/patient/meeting-single-user-record/:meetingId"
                element={<SingleuserMeetingDetail />}
              />
              <Route
                path="/patient/appointment"
                element={<DoctorAppointment />}
              />
              <Route
                path="/patient/meeting-status"
                element={<DoctorMeetingStatus />}
              />
              <Route
                path="/patient-priest/meeting-status"
                element={<DoctorMeetingStatus />}
              />
              <Route
                path="/patient/my-appointments"
                element={<MyAppointments />}
              />
              <Route path="/patient/policy" element={<Policy />} />
              <Route path="/patient/terms" element={<Terms />} />
              <Route path="*" element={<Home />} />
              <Route path="/patient/about-us" element={<AboutUs />} />
              <Route path="/patient/feedback" element={<Feedback />} />
              <Route path="/patient/support" element={<Support />} />
              <Route path="/verify/:token" element={<EmailVerification />} />
              <Route
                path="/patient/appointment/:id"
                element={<BookAppointment />}
              />
              <Route
                path="/patient/share-medical"
                element={<PatientShareMedical />}
              />
              <Route
                path="/patient/permission-code"
                element={<PermissionCode />}
              />
              <Route
                path="/patient/meeting-record/:meetingId"
                element={<MeetingRecord />}
              />
              <Route
                path="/patient/report-generate"
                element={<ReportGenerate />}
              />
              <Route
                path="/patient/report-generate/:uuid"
                element={<ReportGenerate />}
              />
              <Route
                path="/patient/report-generation"
                element={<ReportGeneration />}
              />
              <Route path="/meeting/:meetingid" element={<MeetingRoom />} />
              <Route
                path="/qr_code_prescription/:meeting_id"
                element={<QrCodePrescription />}
              />
              <Route path="/meeting" element={<MeetingRoom />} />
              <Route path="/meeting-trsln" element={<MeetingRoomTrsln />} />
              <Route path="/meeting-trspt" element={<MeetingRoomTrspt />} />
              <Route path="/patient/ai-doctor-2" element={<AiDoctor2 />} />
              <Route path="/patient/ai-doctor-3" element={<AiDoctor3 />} />
              <Route
                path="/patient/choose-options"
                element={<DoctorOptions />}
              />
              <Route path="/patient/ocr" element={<PatientDocsumoResults />} />
              <Route path="/patient/chatgpt" element={<PatientChatgpt />} />
              <Route
                path="/patient/auto-prescription-poc"
                element={<AutoPrescriptionPocPatient />}
              />
              <Route
                path="/patient/auto-prescription"
                element={<AutoPrescription />}
              />
              <Route path="/patient/chatmoslem" element={<ChatMoslem />} />
              <Route
                path="/patient/chatchristian"
                element={<ChatChristian />}
              />
              <Route
                path="/patient/cancercommunity"
                element={<CancerCommunity />}
              />
              <Route
                path="/patient/socialservice"
                element={<SocialService />}
              />
              <Route
                path="/patient/cardiovascularcommunity"
                element={<CardiovascularCommunity />}
              />
              <Route
                path="/patient/diabetescommunity"
                element={<DiabetesCommunity />}
              />
              <Route
                path="/patient/gastrointestinalcommunity"
                element={<GastroIntestinal />}
              />
              <Route
                path="/patient/geriatricscommunity"
                element={<GeriatricsCommunity />}
              />
              <Route
                path="/patient/hypertensioncommunity"
                element={<HypertensionCommunity />}
              />
              <Route
                path="/patient/infeciouscommunity"
                element={<InfeciousCommunity />}
              />{" "}
              <Route path="/doctor/chemist-list" element={<ChemistList />} />
              <Route
                path="/patient/mentalhealthcommunity"
                element={<MentalHealthCommunity />}
              />
              <Route
                path="/patient/obgyncommunity"
                element={<ObGynCommunity />}
              />
              <Route
                path="/patient/pediatricscommunity"
                element={<PediatricsCommunity />}
              />
              <Route
                path="/patient/wellnessnutrition"
                element={<WellnessNutrition />}
              />
              <Route
                path="/patient/feedbacklist"
                element={<PatientFeedbackList />}
              />
              <Route
                path="/patient/feedbackdetail/:id"
                element={<PatientFeedbackDetail />}
              />
              <Route
                path="/patient/newfeedback"
                element={<NewFeedbackPatient />}
              />
              <Route
                path="/patient/single-user-history"
                element={<SingleUserHistory />}
              />
              <Route
                path="/patient-priest/single-user-history"
                element={<SingleUserHistory />}
              />
              <Route
                path="/patient/:room/community"
                element={<MedicalSupprotRoom />}
              />
              <Route
                path="/patient/community"
                element={<PriestSupportRoom />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    );
  } else if (userRole === "2" || userRole === "3") {
    return (
      <div className="App h-100 ">
        <BrowserRouter basename={"/"}>
          <Routes>
            <Route element={<AuthLayout chat={chat} setChat={setChat} />}>
              <Route path="/" element={<DoctorHome />} />
              <Route
                path="/auto-prescription/:id"
                element={<PrescriptionMail />}
              />{" "}
              <Route path="/pastoral-summary/:id" element={<PostralReport />} />
              <Route path="/doctor/home" element={<DoctorHome />} />
              <Route path="/doctor/point-of-care" element={<DoctorPoc />} />
              <Route path="/doctor/feedback" element={<DoctorFeedback />} />
              <Route path="/doctor/support" element={<DoctorSupport />} />
              <Route path="/doctor/patient-list" element={<PatientList />} />
              <Route
                path="/doctor/edit-profile"
                element={<DoctorEditProfile />}
              />
              <Route path="/doctor/share-medical" element={<ShareMedical />} />
              <Route
                path="/doctor/splash-screen"
                element={<DoctorSplashScreen />}
              />
              <Route path="/doctor/about-us" element={<DoctorAboutUs />} />
              <Route path="/doctor/policy" element={<DoctorPolicy />} />
              <Route path="/doctor/terms" element={<DoctorTerms />} />
              <Route path="/doctor/doctor-list" element={<DoctorList />} />
              <Route
                path="/doctor/new-doctor-list"
                element={<NewDoctorList />}
              />
              <Route path="/doctor/isabel" element={<DoctorIsabel />} />
              <Route path="/doctor/prescription" element={<Prescription />} />
              <Route
                path="/doctor/bot-chat-gpt/:poc_type"
                element={<DoctorBotChatGpt />}
              />
              <Route
                path="/doctor/carepoint/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route path="/doctor/starpilot" element={<Starpilot />} />
              <Route
                path="/doctor/single-mic-starpilot"
                element={<SingleMicStarpilotDoctor />}
              />
              <Route
                path="/doctor/single-user-history"
                element={<SingleUserHistory />}
              />
              <Route
                path="/doctor/meeting-single-user-record/:meetingId"
                element={<SingleuserMeetingDetail />}
              />
              <Route
                path="/doctor/auto-prescription-starpilot"
                element={<AutoPrescriptionStarpilot />}
              />
              <Route
                path="/doctor/dr-aiva/:poc_type"
                element={<DoctorSearchChatGpt drAiva={true} />}
              />
              <Route
                path="/doctor/indication-checker/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/drug-interaction-revision/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/drug-allergy/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/dosing-medical-calculation/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/pill-identification/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/medical-videos-articles/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/differential-diagnosis-generator/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/iv-compatibility-checker/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/laboratory-manual/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/icd-11-lookup-tool/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/notes-favorites/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/search-chat-gpt/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/doctor/share-analyse-record/:poc_type"
                element={<DoctorAnalysisChatGpt />}
              />
              <Route
                path="/doctor/doctor-appointment"
                element={<Appointment />}
              />
              <Route path="/doctor/binah" element={<DoctorBinah />} />
              <Route
                path="/doctor/report-generate"
                element={<DoctorReportGenerate />}
              />
              <Route
                path="/doctor/report-generate/:uuid"
                element={<DoctorReportGenerate />}
              />
              <Route
                path="/doctor/report-generation"
                element={<DoctorReportGeneration />}
              />
              <Route
                path="/doctor/doctor-availability"
                element={<DoctorAvailability />}
              />
              <Route
                path="/doctor/patient-appointment"
                element={<PatientAppointment />}
              />
              <Route
                path="/doctor/my-appointment"
                element={<DoctorAppointments />}
              />
              <Route
                path="/doctor/meeting-status"
                element={<MeetingStatus />}
              />
              <Route
                path="/doctor/meeting-single-mic-history"
                element={<SinglemicHistory />}
              />
              <Route
                path="/doctor/meeting-record/:meetingId"
                element={<MeetingRecord />}
              />
              <Route
                path="/doctor/meeting-single-mic-record/:meetingId"
                element={<SinglemicMeetingDetail />}
              />
              <Route
                path="/doctor/patient-waiting"
                element={<PatientWaiting />}
              />
              <Route
                path="/doctor/permission-code-request"
                element={<PermissionCodeRequest />}
              />
              <Route path="/doctor/set-timeslot" element={<SetTimeslot />} />
              <Route
                path="/doctor/share-medical-list"
                element={<ShareMedicalList />}
              />
              <Route
                path="/change-password&securty"
                element={<ChangePassword />}
              />
              <Route path="/logout" element={<Logout />} />
              <Route path="/verify/:token" element={<EmailVerification />} />
              <Route path="*" element={<DoctorHome />} />
              <Route
                path="/meeting/:appointmentid/:meetingid"
                element={<MeetingRoom />}
              />
              <Route
                path="/meeting-trsln/:appointmentid/:meetingid"
                element={<MeetingRoomTrsln />}
              />
              <Route
                path="/meeting-trspt/:appointmentid/:meetingid"
                element={<MeetingRoomTrspt />}
              />
              <Route path="/meetingv2/:meetingid" element={<MeetingRoomV2 />} />
              <Route
                path="/meetingmini/:meetingid"
                element={<MeetingRoomMini />}
              />
              <Route
                path="/meetingo3mini/:meetingid"
                element={<MeetingRoomO3Mini />}
              />
              <Route path="/meeting" element={<MeetingRoom />} />
              <Route path="/meeting-trsln" element={<MeetingRoomTrsln />} />
              <Route path="/meeting-trspt" element={<MeetingRoomTrspt />} />
              <Route
                path="/qr_code_prescription/:meeting_id"
                element={<QrCodePrescription />}
              />
              <Route path="/meetingv2" element={<MeetingRoomV2 />} />
              <Route path="/meetingmini" element={<MeetingRoomMini />} />
              <Route path="/meetingo3mini" element={<MeetingRoomO3Mini />} />
              <Route
                path="/doctor/auto-prescription"
                element={<AutoPrescription />}
              />
              <Route
                path="/doctor/auto-prescription-poc"
                element={<AutoPrescriptionPoc />}
              />
              <Route path="/doctor/chemist-list" element={<ChemistList />} />
              <Route path="/doctor/ocr" element={<DocsumoResults />} />
              <Route path="/doctor/chatgpt" element={<Chatgpt />} />
              <Route
                path="/doctor/radiography&dermatology-illustration/:poc_type"
                element={<DocScanChatGpt from={"Doctor"} />}
              />
              <Route
                path="/doctor/choose-options"
                element={<DoctorOwnOptions />}
              />
              <Route path="/doctor/ai-doctor-2" element={<DocAiDoctor2 />} />
              <Route path="/doctor/ai-doctor-3" element={<DocAiDoctor3 />} />
              <Route path="/doctor/chatmoslem" element={<ChatMoslem />} />
              <Route path="/doctor/chatchristian" element={<ChatChristian />} />
              <Route
                path="/doctor/cancercommunity"
                element={<CancerCommunity />}
              />
              <Route
                path="/doctor/cardiovascularcommunity"
                element={<CardiovascularCommunity />}
              />
              <Route path="/doctor/socialservice" element={<SocialService />} />
              <Route
                path="/doctor/diabetescommunity"
                element={<DiabetesCommunity />}
              />
              <Route
                path="/doctor/gastrointestinalcommunity"
                element={<GastroIntestinal />}
              />
              <Route
                path="/doctor/geriatricscommunity"
                element={<GeriatricsCommunity />}
              />
              <Route
                path="/doctor/hypertensioncommunity"
                element={<HypertensionCommunity />}
              />
              <Route
                path="/doctor/infeciouscommunity"
                element={<InfeciousCommunity />}
              />
              <Route
                path="/doctor/mentalhealthcommunity"
                element={<MentalHealthCommunity />}
              />
              <Route
                path="/doctor/obgyncommunity"
                element={<ObGynCommunity />}
              />
              <Route
                path="/doctor/pediatricscommunity"
                element={<PediatricsCommunity />}
              />
              <Route
                path="/doctor/wellnessnutrition"
                element={<WellnessNutrition />}
              />
              <Route
                path="/doctor/feedbacklist"
                element={<DoctorFeedbackList />}
              />
              <Route
                path="/doctor/feedbackdetail/:id"
                element={<DoctorFeedbackDetail />}
              />
              <Route
                path="/doctor/newfeedback"
                element={<NewFeedbackDoctor />}
              />
              <Route
                path="/doctor/:room/community"
                element={<MedicalSupprotRoom />}
              />
              <Route path="/doctor/community" element={<PriestSupportRoom />} />
              <Route
                path="/meeting-single-mic"
                element={<MeetingInitialize />}
              />
              <Route
                path="/meeting-single-mic/:appointmentid/:meetingid"
                element={<MeetingRoomSingleMic />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    );
  } else {
    return (
      <div className="App h-100 ">
        <BrowserRouter basename={"/"}>
          <Routes>
            <Route element={<AuthLayout chat={chat} setChat={setChat} />}>
              <Route path="/" element={<PriestHome />} />
              <Route
                path="/auto-prescription/:id"
                element={<PrescriptionMail />}
              />
              <Route path="/pastoral-summary/:id" element={<PostralReport />} />
              <Route path="/priest/home" element={<PriestHome />} />
              <Route path="/priest/point-of-care" element={<DoctorPoc />} />
              <Route path="/priest/feedback" element={<DoctorFeedback />} />
              <Route path="/priest/support" element={<DoctorSupport />} />
              <Route path="/priest/patient-list" element={<PatientList />} />
              <Route
                path="/priest/edit-profile"
                element={<DoctorEditProfile />}
              />
              <Route path="/priest/share-medical" element={<ShareMedical />} />
              <Route
                path="/priest/splash-screen"
                element={<SplashScreenPriest />}
              />
              <Route path="/priest/about-us" element={<DoctorAboutUs />} />
              <Route path="/priest/policy" element={<DoctorPolicy />} />
              <Route path="/priest/terms" element={<DoctorTerms />} />
              <Route path="/priest/doctor-list" element={<DoctorList />} />
              <Route
                path="/priest/new-doctor-list"
                element={<NewDoctorList />}
              />
              <Route path="/priest/isabel" element={<DoctorIsabel />} />
              <Route path="/priest/prescription" element={<Prescription />} />
              <Route
                path="/priest/bot-chat-gpt/:poc_type"
                element={<DoctorBotChatGpt />}
              />
              <Route
                path="/priest/carepoint/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route path="/priest/starpilot" element={<Starpilot />} />
              <Route
                path="/priest/single-mic-starpilot"
                element={<SingleMicStarpilotDoctor />}
              />
              <Route
                path="/priest/single-user-history"
                element={<SingleUserHistory />}
              />

              <Route
                path="/priest/meeting-single-user-record/:meetingId"
                element={<SingleuserMeetingDetail />}
              />
              <Route
                path="/doctor/auto-prescription-starpilot"
                element={<AutoPrescriptionStarpilot />}
              />
              <Route
                path="/priest/dr-aiva/:poc_type"
                element={<DoctorSearchChatGpt drAiva={true} />}
              />
              <Route
                path="/priest/indication-checker/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/drug-interaction-revision/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/drug-allergy/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/dosing-medical-calculation/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/pill-identification/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/medical-videos-articles/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/differential-diagnosis-generator/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/iv-compatibility-checker/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/laboratory-manual/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/icd-11-lookup-tool/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/auto-prescription-starpilot"
                element={<AutoPrescriptionStarpilot />}
              />
              <Route
                path="/priest/notes-favorites/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/search-chat-gpt/:poc_type"
                element={<DoctorSearchChatGpt />}
              />
              <Route
                path="/priest/share-analyse-record/:poc_type"
                element={<DoctorAnalysisChatGpt />}
              />
              <Route
                path="/doctor/doctor-appointment"
                element={<Appointment />}
              />
              <Route path="/priest/binah" element={<DoctorBinah />} />
              <Route
                path="/priest/report-generate"
                element={<DoctorReportGenerate />}
              />
              <Route
                path="/priest/report-generate/:uuid"
                element={<DoctorReportGenerate />}
              />
              <Route
                path="/priest/report-generation"
                element={<DoctorReportGeneration />}
              />
              <Route
                path="/doctor/doctor-availability"
                element={<DoctorAvailability />}
              />
              <Route
                path="/priest/patient-appointment"
                element={<PatientAppointment />}
              />
              <Route
                path="/priest/my-appointment"
                element={<DoctorAppointments />}
              />
              <Route
                path="/priest/meeting-status"
                element={<MeetingStatus />}
              />
              <Route
                path="/priest/meeting-single-mic-history"
                element={<SinglemicHistory />}
              />
              <Route
                path="/priest/meeting-record/:meetingId"
                element={<MeetingRecord />}
              />
              <Route
                path="/priest/meeting-single-mic-record/:meetingId"
                element={<SinglemicMeetingDetail />}
              />

              <Route
                path="/priest/patient-waiting"
                element={<PatientWaiting />}
              />
              <Route
                path="/priest/permission-code-request"
                element={<PermissionCodeRequest />}
              />
              <Route path="/priest/set-timeslot" element={<SetTimeslot />} />
              <Route
                path="/priest/share-medical-list"
                element={<ShareMedicalList />}
              />
              <Route
                path="/change-password&securty"
                element={<ChangePassword />}
              />
              <Route path="/logout" element={<Logout />} />
              <Route path="/verify/:token" element={<EmailVerification />} />
              <Route path="*" element={<DoctorHome />} />

              <Route
                path="/meeting/:appointmentid/:meetingid"
                element={<MeetingRoom />}
              />
              <Route
                path="/meeting-trsln/:appointmentid/:meetingid"
                element={<MeetingRoomTrsln />}
              />
              <Route
                path="/meeting-trspt/:appointmentid/:meetingid"
                element={<MeetingRoomTrspt />}
              />
              <Route path="/meetingv2/:meetingid" element={<MeetingRoomV2 />} />
              <Route
                path="/meetingmini/:meetingid"
                element={<MeetingRoomMini />}
              />
              <Route
                path="/meetingo3mini/:meetingid"
                element={<MeetingRoomO3Mini />}
              />

              <Route path="/meeting" element={<MeetingRoom />} />
              <Route path="/meeting-trsln" element={<MeetingRoomTrsln />} />
              <Route path="/meeting-trspt" element={<MeetingRoomTrspt />} />
              <Route
                path="/qr_code_prescription/:meeting_id"
                element={<QrCodePrescription />}
              />
              <Route path="/meetingv2" element={<MeetingRoomV2 />} />
              <Route path="/meetingmini" element={<MeetingRoomMini />} />
              <Route path="/meetingo3mini" element={<MeetingRoomO3Mini />} />
              <Route
                path="/priest/auto-prescription"
                element={<AutoPrescription />}
              />
              <Route
                path="/priest/auto-prescription-poc"
                element={<AutoPrescriptionPoc />}
              />
              <Route path="/priest/chemist-list" element={<ChemistList />} />
              <Route path="/priest/ocr" element={<DocsumoResults />} />
              <Route path="/priest/chatgpt" element={<Chatgpt />} />
              <Route
                path="/priest/radiography&dermatology-illustration/:poc_type"
                element={<DocScanChatGpt from={"Doctor"} />}
              />
              <Route
                path="/priest/choose-options"
                element={<DoctorOwnOptions />}
              />

              <Route path="/priest/ai-doctor-2" element={<DocAiDoctor2 />} />
              <Route path="/priest/ai-doctor-3" element={<DocAiDoctor3 />} />

              <Route path="/priest/chatmoslem" element={<ChatMoslem />} />
              <Route path="/priest/chatchristian" element={<ChatChristian />} />

              <Route
                path="/doctor/cancercommunity"
                element={<CancerCommunity />}
              />
              <Route
                path="/priest/cardiovascularcommunity"
                element={<CardiovascularCommunity />}
              />
              <Route path="/priest/socialservice" element={<SocialService />} />
              <Route
                path="/priest/diabetescommunity"
                element={<DiabetesCommunity />}
              />
              <Route
                path="/priest/gastrointestinalcommunity"
                element={<GastroIntestinal />}
              />
              <Route
                path="/priest/geriatricscommunity"
                element={<GeriatricsCommunity />}
              />
              <Route
                path="/priest/hypertensioncommunity"
                element={<HypertensionCommunity />}
              />
              <Route
                path="/priest/infeciouscommunity"
                element={<InfeciousCommunity />}
              />
              <Route
                path="/priest/mentalhealthcommunity"
                element={<MentalHealthCommunity />}
              />
              <Route
                path="/priest/obgyncommunity"
                element={<ObGynCommunity />}
              />
              <Route
                path="/priest/pediatricscommunity"
                element={<PediatricsCommunity />}
              />
              <Route
                path="/priest/wellnessnutrition"
                element={<WellnessNutrition />}
              />
              <Route
                path="/priest/feedbacklist"
                element={<DoctorFeedbackList />}
              />
              <Route
                path="/priest/feedbackdetail/:id"
                element={<DoctorFeedbackDetail />}
              />
              <Route
                path="/priest/newfeedback"
                element={<NewFeedbackDoctor />}
              />
              <Route
                path="/priest/:room/community"
                element={<MedicalSupprotRoom />}
              />
              <Route path="/priest/livestreaming" element={<LiveStreaming />} />

              <Route path="/priest/community" element={<PriestSupportRoom />} />
              <Route
                path="/meeting-single-mic"
                element={<MeetingInitialize />}
              />
              <Route
                path="/meeting-single-mic/:appointmentid/:meetingid"
                element={<MeetingRoomSingleMic />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
